import { AppData } from '@ai-platform/utils';

const validStatuses = ['VALID', 'NEED_RESET'];

export function isAuthorizedByBlackbox(user: AppData['user']) {
    return Boolean(
        user &&
            // Не должно быть ошибки
            (!user.error || user.error === 'OK') &&
            // Должен быть статус 'VALID' или 'NEED_RESET'
            (!user.status || validStatuses.includes(user.status)),
    );
}

export function getAvatarSrc(avatar?: string) {
    if (!avatar) {
        return 'https://avatars.mds.yandex.net/get-yapic/18057972/NbnfpFSzqQp5FluiuEdXK61dkg-1/islands-200';
    }

    return `https://avatars.mds.yandex.net/get-yapic/${avatar}/islands-200`;
}
